module.exports = __webpack_public_path__ + "static/media/RI.a2f7ee89.png";